import PropTypes from "prop-types";

import { CollegeMajorsCard as CommonCollegeMajorsCard } from "../../../../core/compose/cards";

function CollegeMajorsCard({
  id,
  open,
  chosenSchool,
  externalToggle,
  callbackToggle,
}) {
  return (
    <CommonCollegeMajorsCard
      id={id}
      open={open}
      chosenSchool={chosenSchool}
      externalToggle={externalToggle}
      callbackToggle={callbackToggle}
    />
  );
}

CollegeMajorsCard.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  externalToggle: PropTypes.bool,
  callbackToggle: PropTypes.func,
  chosenSchool: PropTypes.shape(),
};

export default CollegeMajorsCard;
